import React, { Component } from 'react';
import { Row, Button, message, Spin, DatePicker, Col, List, InputNumber, Select, Popconfirm } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import Auth from "../../../table/Auth";
import "./index.scss";

const { MonthPicker } = DatePicker;
const { Option } = Select;

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            dateData: [],
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            hotels: []
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }


    getDateData = (date) => {
        let data = new Array(10).fill({ name: "", hotel_id: "", num: 0 }).map(x => ({ ...x }));
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getOtaFillIn?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data;
            }
            this.setState({ loading: false, data, hotels: x.data.hotels });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addOtaFillIn', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }


    onChange = (name, value, i) => {
        let data = [...this.state.data];
        data[i][name] = value;
        this.setState({ data });
    }

    onDelete = async (item, index) => {
        try {
            let data = [...this.state.data];

            if (!item.id) {
                data.splice(index, 1);
                this.setState({ data });
                return
            }

            let res = await fetch(`/deleteOtaFillIn?id=${item.id}`, { credentials: 'include' });
            let json = await res.json();

            if (json.status == 1) {
                data.splice(index, 1);
                this.setState({ data });
                return
            }
            message.error(json.msg);
        } catch (error) {
            console.log(error);
            message.error('删除错误');
        }
    }

    render() {
        const { data, hotels, loading, print, date } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 ota-channel">
                    <Row className="title" id="table4_1_1" style={{ width: print ? 4450 : 'auto' }}>
                        <Row>Hotel OTA Channel Performance 酒店OTA渠道表现</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>


                    </Row>
                    <Row className="content">
                        <List
                            className={`${data.length >= 11 && 'padding-right-scroll'}`}
                            header={<Row>
                                <Col span={2} className="border-right padding">key</Col>
                                <Col span={14} className="border-right padding ">酒店名称</Col>
                                <Col span={6} className="border-right padding">数量</Col>
                                <Col span={2} className="padding">操作</Col>
                            </Row>}
                        >
                            {
                                [...data].map((item, index) => {
                                    return <List.Item key={index}>
                                        <Col
                                            span={2}
                                            className="padding border-right"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                height: 48
                                            }}
                                        >
                                            {index + 1}
                                        </Col>
                                        <Col span={14} className="input_color padding">
                                            <Select
                                                showSearch
                                                placeholder="请选择酒店"
                                                className="table_numInput"
                                                optionFilterProp="children"
                                                value={item.name}
                                                onChange={v => {
                                                    const hotel = hotels.find(x => x.name.includes(v)) || {};

                                                    this.onChange('name', v, index);
                                                    this.onChange('hotel_id', hotel.id || "", index);
                                                }}
                                            >
                                                {
                                                    hotels.map(x => {
                                                        const name = x.name.replace(/[^\u4E00-\u9FA5]/g, "");
                                                        return <Option key={name}>{name}</Option>
                                                    })
                                                }
                                            </Select>
                                        </Col>
                                        <Col span={6} className="input_color padding">
                                            <InputNumber
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                precision={0}
                                                className="table_numInput"
                                                value={Number(item.num || "0") || ""}
                                                onChange={v => {
                                                    this.onChange('num', v, index);
                                                }}
                                            />
                                        </Col>
                                        <Popconfirm
                                            title="确定删除吗,一单删除将不可恢复?"
                                            onConfirm={this.onDelete.bind(this, item, index)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <Col
                                                span={2}
                                                className="padding"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#4c9bf2"
                                                }}
                                            >
                                                删除
                                        </Col>
                                        </Popconfirm>

                                    </List.Item>
                                })
                            }
                        </List>
                    </Row>
                    <Button
                        ghost
                        className="add-hotel"
                        icon="plus"
                        type="primary"
                        onClick={() => {
                            let data = [...this.state.data];
                            data.push({ name: "", hotel_id: "", num: 0 });
                            this.setState({ data });
                        }}
                    >添加酒店</Button>
                    <Row className="table-footer-btn">
                        {/* <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button> */}
                        <Auth loading={this.state.loading} auth="edit_otafillin">
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>

            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/OTAChannel/fillIn/index.js